import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "sonner";
import TawkToChat from "./components/TawkToChat";
import GoogleAnalytics from "./components/GoogleAnalytics";
import DynamicFavicon from "./components/DynamicFavicon";

// Google Analytics Measurement ID - Configure in environment or here
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || null;

// Pages
import HomePage from "./pages/HomePage";
import EquipmentPage from "./pages/EquipmentPage";
import ServicesPage from "./pages/ServicesPage";
import ReferencesPage from "./pages/ReferencesPage";
import PartnersPage from "./pages/PartnersPage";
import PartnerDetailPage from "./pages/PartnerDetailPage";
import BecomePartnerPage from "./pages/BecomePartnerPage";
import ClientFeedbackPage from "./pages/ClientFeedbackPage";
import EventsPage from "./pages/EventsPage";
import ContactPage from "./pages/ContactPage";
import LoginPage from "./pages/LoginPage";
import AdminPage from "./pages/AdminPage";
import UnauthorizedPage from "./pages/UnauthorizedPage";

// Components
import AuthCallback from "./components/AuthCallback";
import ProtectedRoute from "./components/ProtectedRoute";

// Router component that handles auth callback detection
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment (not query params) for session_id - detect SYNCHRONOUSLY during render
  // This prevents race conditions by processing new session_id FIRST before checking existing session_token
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/equipment" element={<EquipmentPage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/references" element={<ReferencesPage />} />
      <Route path="/partners" element={<PartnersPage />} />
      <Route path="/partner/:id" element={<PartnerDetailPage />} />
      <Route path="/become-partner" element={<BecomePartnerPage />} />
      <Route path="/client-feedback" element={<ClientFeedbackPage />} />
      <Route path="/events" element={<EventsPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />
      <Route 
        path="/lina" 
        element={
          <ProtectedRoute requireAdmin>
            <AdminPage />
          </ProtectedRoute>
        } 
      />
      {/* /admin désactivé - redirige vers 404 */}
      <Route path="/admin" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <LanguageProvider>
          <div className="App">
            <DynamicFavicon />
            <GoogleAnalytics measurementId={GA_MEASUREMENT_ID} />
            <AppRouter />
            <Toaster position="top-right" richColors />
            <TawkToChat />
          </div>
        </LanguageProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
